// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Key (round) icon with a "+" badge in the top-right corner.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function KeyPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M15 14.94a6.5 6.5 0 0 1-1.6-.34l-.814.814a2 2 0 0 1-1.414.586H11a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.172a2 2 0 0 1 .586-1.414L9.4 10.6a6.5 6.5 0 1 1 11.224 1.9" />
      <path d="M19 16v6" />
      <path d="M22 19h-6" />
      <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
    </svg>
  );
}
